import fetch from '../api/fetch'

/**
 * 	Action to fetch the renewals list
 *
 * 	@method GET
 */

export function fecthRenewalsList(
    page: number = 1,
    perPage: number = 20,
    sortedBy: string = 'clientName',
    sortedType: string = 'asc',
    userId: number
) {

    let params =
        `?page=${page}&perPage=${perPage}&sortedBy=${sortedBy}&sortedType=${sortedType}&userId=${userId ? userId : ''}`

    return {
        type: 'FETCH_RENEWALS_LIST',
        payload: fetch(`/renewals${params}`, { method: 'GET' }),
    }
}

/**
 * 	Action to lapse a renewal
 *
 * 	@method POST
 */

export function fecthLapseRenewal(policyId: any) {

    return {
        type: 'FETCH_LAPSE_RENEWAL',
        payload: fetch(`/policies/${policyId}/lapse`, { method: 'POST' }),
    }
}

/**
 * 	Action to renew a policy
 *
 * 	@method POST
 */

export function fecthRenewPolicy(policyId: any) {

    return {
        type: 'FETCH_RENEW_POLICY',
        payload: fetch(`/policies/${policyId}/renewal`, { method: 'POST' }),
    }
}

/**
 * 	Action to renew as it is
 *
 * 	@method GET
 */

export function fecthRenewAsIs(policyId: any) {

    return {
        type: 'FETCH_RENEW_AS_IS',
        payload: fetch(`/policies/${policyId}/renewal`, { method: 'GET' }),
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/actions/renewals.ts